// Signing out clears the SESSION, not the browser.
//
// Every logout path used to call localStorage.clear(), which empties the whole origin —
// and the CSC Saved Sets live there (csc_history_v1), as do a few per-browser
// preferences. So an overnight refresh-token expiry wiped a day's saved working sets
// along with the token: the agent came in the next morning to "Saved Sets (0/10)" with
// nothing they did wrong and nothing to undo.
// (user 2026-11-03: "save set is gone ... ytd stil ok. morning then wiped")
//
// These keys are NOT identity. They are the scratchpad and the view preferences of
// whoever sits at this browser, they are never sent anywhere, and nothing in them leaks
// one user's data to the next: a shared machine shows the previous agent's saved CSC
// workings either way, because clear() only ever ran at logout and never at login.
// If that ever becomes a concern the answer is to key them per user, not to delete them.
const KEEP_THROUGH_LOGOUT = [
    'csc_history_v1',      // CSC Saved Sets — up to ten working sets
    'rsc_promoRemarks',    // the agent's own promo wording
    'rsc2_promoRemarks',
    'sop-lang', 'sop-role', 'sop-speed',   // SOP reading preferences
    'schedulingView', 'EventsView',        // which view a page opens on
];

/**
 * Clear the signed-in session from this browser, keeping the local scratchpad.
 * Use this everywhere instead of localStorage.clear().
 */
export function clearAuthStorage() {
    let kept = [];
    try {
        kept = KEEP_THROUGH_LOGOUT
            .map(k => [k, localStorage.getItem(k)])
            .filter(([, v]) => v != null);
    } catch { /* private mode — nothing to keep */ }

    try { localStorage.clear(); } catch { /* ignore */ }
    try { sessionStorage.clear(); } catch { /* ignore */ }

    for (const [k, v] of kept) {
        try { localStorage.setItem(k, v); } catch { /* quota — the session is still cleared */ }
    }
}

export const LOGOUT_KEEP_KEYS = KEEP_THROUGH_LOGOUT;
